import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Signer = {
  id: string;
  name: string;
  email: string;
  country: string;
  city: string | null;
  affiliation: string | null;
  comment: string | null;
  hide_name: boolean;
  hide_affiliation: boolean;
  agree_privacy: boolean;
  agree_display: boolean;
  created_at: string;
  updated_at: string;
  is_signature: boolean;
  likes: number;
  occupation: string | null;
  age_group: string | null;
  region: string | null;
  organization_name: string | null;
  is_organization_rep: boolean;
  join_100_list: boolean;
  phone: string | null;
  user_id: string | null;
};

export type Organization = {
  id: string;
  name: string;
  type: string;
  representative_name: string | null;
  representative_signer_id: string | null;
  member_count: number;
  created_at: string;
  updated_at: string;
};

export type Comment = {
  id: string;
  name: string;
  message: string;
  likes: number;
  is_best: boolean;
  created_at: string;
  updated_at: string;
};
